import { roleSchema } from '#src/access/roles.contract.js';
import { definePolicy, listQuerySchema } from '#src/rsql/index.js';
const text = {
    type: 'string',
    wildcards: true,
    caseInsensitive: true,
};
/**
 * O que `GET /api/access/roles` deixa filtrar, ordenar e pedir.
 * `permissions` vale quando alguma permissão do perfil bate.
 */
export const rolesPolicy = definePolicy({
    fields: {
        code: { ...text, sortable: true },
        name: { ...text, sortable: true },
        description: text,
        active: { type: 'boolean' },
        permissions: { type: 'string' },
        createdAt: { type: 'datetime', sortable: true },
    },
    defaultSort: [{ field: 'name', direction: 'asc' }],
    selectable: roleSchema.keyof().options,
});
export const rolesQuerySchema = listQuerySchema(rolesPolicy);
//# sourceMappingURL=roles.policy.js.map